import React from 'react';
import ReactDOM from 'react-dom';
import { connect, Provider } from 'react-redux';
import AddedValueMessagesListing from '../AddedValueMessages/AddedValueMessagesListing';

export default function initAddedValueMessages() {
  const products = window.digitalData.products || [];
  const avmWrapper = document.querySelectorAll('[data-component="avms"]');
  
  function mapStateToProps(state) {
    return {
      view: state.listingPage.pageSetup.viewSwitch
    };
  }
  const ConnectedAvms = connect(mapStateToProps)(AddedValueMessagesListing);

  [...avmWrapper].forEach((mountEl) => {
    const productId = mountEl.getAttribute('data-productid');
    const currentProduct = products.filter(
      (product) => product.productID === productId
    ).shift();

    if (!avmWrapper) {
      return;
    }
    
    if (avmWrapper) {
      ReactDOM.render(
        <Provider store={window.appState}>
          <ConnectedAvms data={currentProduct.addedValueMessages} />
        </Provider>, mountEl
      );
    }
  });
}
